"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactVis = require("react-vis");

var _luxon = require("luxon");

var _styles = require("../../styles");

var _ResizableXYPlot = _interopRequireDefault(require("../ResizableXYPlot"));

var _noDataInsert = _interopRequireDefault(require("../noDataInsert"));

var _SplitLineSeries = _interopRequireDefault(require("../SplitLineSeries"));

var _SplitAreaSeries = _interopRequireDefault(require("../SplitAreaSeries"));

require("react-vis/dist/style.css");

var _colors = require("../../constants/colors");

var _propTypes2 = require("../../constants/propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getWeekFormat = function getWeekFormat(t, timeZone) {
  return _luxon.DateTime.fromJSDate(t, {
    zone: timeZone
  }).toFormat('HH') === '12' ? _luxon.DateTime.fromJSDate(t, {
    zone: timeZone
  }).toFormat('D') : '';
};

var Display = function Display(_ref) {
  var displayCoordinates = _ref.displayCoordinates,
      hasBattery = _ref.hasBattery,
      isLoading = _ref.isLoading,
      timeZone = _ref.timeZone,
      endMillis = _ref.endMillis,
      startMillis = _ref.startMillis;
  var batteryChargeCoordinates = displayCoordinates.batteryChargeCoordinates,
      batteryDischargeCoordinates = displayCoordinates.batteryDischargeCoordinates,
      consumptionCoordinates = displayCoordinates.consumptionCoordinates,
      exportAreaCoordinates = displayCoordinates.exportAreaCoordinates,
      importCoordinates = displayCoordinates.importCoordinates,
      selfConsumptionCoordinates = displayCoordinates.selfConsumptionCoordinates,
      solarCoordinates = displayCoordinates.solarCoordinates;
  var isOverOneDay = endMillis - startMillis > 86400000;
  return /*#__PURE__*/_react["default"].createElement(_ResizableXYPlot["default"], {
    dataTestid: "daily-chart",
    animation: "noAnimation",
    height: 300,
    margin: {
      left: 70,
      right: 0
    },
    xDomain: [startMillis, endMillis],
    xType: "time"
  }, /*#__PURE__*/_react["default"].createElement(_reactVis.GradientDefs, null, /*#__PURE__*/_react["default"].createElement("pattern", {
    id: "export-crosshatch",
    width: "4",
    height: "4",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "vx-pattern-line",
    d: "M 0,4 l 4,-4 M -1,1 l 2,-2 M 3,5 l 2,-2",
    stroke: _colors.DARK_GREY,
    strokeWidth: "1",
    strokeLinecap: "square",
    shapeRendering: "auto"
  }))), /*#__PURE__*/_react["default"].createElement(_reactVis.HorizontalGridLines, {
    style: _styles.dashedGridStyle
  }), (0, _noDataInsert["default"])(startMillis, endMillis, isLoading, batteryChargeCoordinates, batteryDischargeCoordinates, consumptionCoordinates, exportAreaCoordinates, selfConsumptionCoordinates, solarCoordinates), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: importCoordinates,
    delta: 15,
    key: "importCoordinates",
    style: _styles.importAreaStyle,
    unit: "minute"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: solarCoordinates,
    delta: 15,
    style: _styles.solarAreaStyle,
    unit: "minute"
  }), /*#__PURE__*/_react["default"].createElement(_SplitLineSeries["default"], {
    data: consumptionCoordinates,
    delta: 15,
    key: "consumptionCoordinates",
    style: _styles.consumptionLineStyle,
    unit: "minute"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: selfConsumptionCoordinates,
    delta: 15,
    key: "selfConsumptionCoordinates",
    style: _styles.selfConsumptionAreaStyle,
    unit: "minute"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: exportAreaCoordinates,
    delta: 15,
    key: "exportAreaCoordinates",
    style: _styles.exportCrosshatchStyle,
    unit: "minute"
  }), hasBattery && [/*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: batteryDischargeCoordinates,
    delta: 15,
    key: "batteryDischargeAreaCoordinates",
    style: _styles.batteryDischargeStyle,
    unit: "minute"
  }), /*#__PURE__*/_react["default"].createElement(_SplitAreaSeries["default"], {
    data: batteryChargeCoordinates,
    delta: 15,
    key: "batteryChargeAreaCoordinates",
    style: _styles.batteryChargeStyle,
    unit: "minute"
  })], /*#__PURE__*/_react["default"].createElement(_reactVis.XAxis, {
    tickFormat: function tickFormat(t) {
      return isOverOneDay ? getWeekFormat(t, timeZone) : _luxon.DateTime.fromJSDate(t, {
        zone: timeZone
      }).toFormat('hh a');
    },
    tickTotal: isOverOneDay ? 168 : 24,
    style: _styles.axisStyle
  }));
};

Display.propTypes = {
  displayCoordinates: _propTypes["default"].shape({
    batteryChargeCoordinates: _propTypes2.coordinatePropTypes,
    batteryDischargeCoordinates: _propTypes2.coordinatePropTypes,
    consumptionCoordinates: _propTypes2.coordinatePropTypes,
    exportAreaCoordinates: _propTypes2.coordinatePropTypes,
    selfConsumptionCoordinates: _propTypes2.coordinatePropTypes,
    solarCoordinates: _propTypes2.coordinatePropTypes,
    importCoordinates: _propTypes2.coordinatePropTypes
  }),
  endMillis: _propTypes["default"].number.isRequired,
  hasBattery: _propTypes["default"].bool,
  isLoading: _propTypes["default"].bool,
  startMillis: _propTypes["default"].number.isRequired,
  timeZone: _propTypes["default"].string
};
Display.defaultProps = {
  displayCoordinates: {},
  hasBattery: false,
  isLoading: false,
  timeZone: 'local'
};
var _default = Display;
exports["default"] = _default;